export default {
      id: "call-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svgsprite.svg#call",
      toString: function () {
        return this.url;
      }
    }